import { store } from '@/store';
import { CheckboxFormFieldBuilder } from '.';
import { config } from '../config';
import type { FormField, IFormCheckbox } from '../typings';
import { setConditionalChildFields } from '../store';

export abstract class DefaultFormFieldBuilder<T> {
  protected _name: string = 'Name not provided';
  protected _fieldId: string = 'FieldId not provided';
  protected _notApplicable: boolean = false;
  protected _hint?: string;
  protected _hintImageUrl?: string;
  protected _notApplicableField?: IFormCheckbox;
  protected _hasAnyValue: boolean = false;
  protected _parentFieldId?: string;
  protected _naDetails?: FormField;

  protected constructor() {}

  public name(value: string): this {
    this._name = value;
    return this;
  }

  public fieldId(value: string): this {
    this._fieldId = value;
    return this;
  }

  public hint(value: string): this {
    this._hint = value;
    return this;
  }

  public hintImageUrl(value: string): this {
    this._hintImageUrl = value;
    return this;
  }

  public notApplicable(value: boolean): this {
    this._notApplicable = value;

    return this;
  }

  public showNotApplicable(value: boolean): this {
    if (value) {
      this._notApplicableField = new CheckboxFormFieldBuilder()
        .name(`${this._fieldId}${config.notApplicableFieldSuffix}`)
        .fieldId(`${this._fieldId}${config.notApplicableFieldSuffix}`)
        .label('Not Applicable')
        .value(this._notApplicable)
        .build();
    }
    return this;
  }

  public hasAnyValue(value: boolean): this {
    this._hasAnyValue = value;
    return this;
  }

  public naDetails(value: FormField): this {
    this._naDetails = value;
    return this;
  }

  public parentFieldId(value?: string): this {
    this._parentFieldId = value;

    if (this._parentFieldId) {
      store.dispatch(
        setConditionalChildFields({
          [this._fieldId]: {
            parentFieldId: this._parentFieldId,
            hasAnyValue: this._hasAnyValue,
          },
        }),
      );
    }

    return this;
  }

  public build(): T {
    return Object.keys(this)
      .filter(key => key.startsWith('_'))
      .reduce(
        (obj, key) => ({
          ...obj,
          [key.slice(1)]: this[key as keyof this],
        }),
        {} as T,
      );
  }
}
